import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Wrapper } from './s'
import { File, Image, Music as Audio, Video, FileText, Table as Spreadsheet, Monitor as Presentation } from 'styled-icons/feather'
import { SmartDocument, FileRichText } from 'components/feather'
import { Pdf } from 'components/icon'
import { FileZip as Archive } from 'styled-icons/remix-line'
import { Brush as Design } from 'styled-icons/bootstrap'

const DocumentType = ({ type }) => {
    if(!type) {
        return null
    }

    const Icon = typeToIconMap[type] ?? File
    const name = typeToNameMap[type]

    if(!name) {
        return null
    }

    return (
        <Wrapper>
            <Icon />
            <span>
                <FormattedMessage {...name} />
            </span>
        </Wrapper>
    )
}

const typeToIconMap = {
    smart: ({ size = 20, ...props }) => <SmartDocument {...props} size={size} />,
    file: ({ size = 20, ...props }) => <File {...props} size={size} />,
    text: ({ size = 20, ...props }) => <FileText {...props} size={size} />,
    rich: ({ size = 20, ...props }) => <FileRichText {...props} size={size} />,
    pdf: ({ size = 20, ...props }) => <Pdf {...props} size={size} />,
    spreadsheet: ({ size = 20, ...props }) => <Spreadsheet {...props} size={size} />,
    presentation: ({ size = 20, ...props }) => <Presentation {...props} size={size} />,
    image: ({ size = 20, ...props }) => <Image {...props} size={size} />,
    design: ({ size = 20, ...props }) => <Design {...props} size={size} />,
    audio: ({ size = 20, ...props }) => <Audio {...props} size={size} />,
    video: ({ size = 20, ...props }) => <Video {...props} size={size} />,
    archive: ({ size = 20, ...props }) => <Archive {...props} size={size} />
}

const typeToNameMap = {
    smart: {
        id: 'documents_smart_documents',
        defaultMessage: 'Smart documents'
    },
    file: {
        id: 'document_type_file',
        defaultMessage: 'File'
    },
    text: {
        id: 'document_type_plain_text',
        defaultMessage: 'Plain text'
    },
    rich: {
        id: 'document_type_rich_text',
        defaultMessage: 'Rich text'
    },
    pdf: {
        id: 'document_type_pdf',
        defaultMessage: 'PDF'
    },
    spreadsheet: {
        id: 'document_type_spreadsheet_plural',
        defaultMessage: 'Spreadsheets'
    },
    presentation: {
        id: 'document_type_presentation_plural',
        defaultMessage: 'Presentations'
    },
    image: {
        id: 'document_type_image_plural',
        defaultMessage: 'Images'
    },
    design: {
        id: 'document_type_design',
        defaultMessage: 'Graphic design'
    },
    audio: {
        id: 'document_type_audio',
        defaultMessage: 'Audio'
    },
    video: {
        id: 'document_type_video_plural',
        defaultMessage: 'Videos'
    },
    archive: {
        id: 'document_type_archive',
        defaultMessage: 'Archive (zip)'
    }
}

export default DocumentType